// Generated by ReScript, PLEASE EDIT WITH CARE


var dupicateModalTitle = {
  id: "29cd87a3-bafd-4c83-abf8-4f08f67a2619",
  defaultMessage: "Duplicate grid {duplicate}"
};

var duplicateInto = {
  id: "aa6b3ad3-f0c4-4302-8763-7168a1b99220",
  defaultMessage: "Duplicate to"
};

var newGrid = {
  id: "9fc69df6-9257-4e2d-8fe7-409fe58ce155",
  defaultMessage: "New grid"
};

var existingGrid = {
  id: "130600da-bb43-4484-ad94-08f6dc8a9273",
  defaultMessage: "Existing grids"
};

var duplicateSuccess = {
  id: "8d3206ab-ecf7-41e3-8b7e-66fcacaf2a6c",
  defaultMessage: "Duplication was successful"
};

var duplicateFail = {
  id: "58c28b46-8fec-4c8f-a9ac-937b0181db26",
  defaultMessage: "Duplication failed. Refresh window and try again"
};

var duplicationDates = {
  id: "32274362-83bd-4b4e-a464-61140ef5559d",
  defaultMessage: "Duplication will be applied on following dates"
};

var periodSelection = {
  id: "0eb72ff2-e69c-49db-b0b3-9a9e19fecc4e",
  defaultMessage: "1. Select year of the period"
};

var duplicateTransferHeader = {
  id: "86aa24e7-9fb4-4ffe-aece-0699bb4451d1",
  defaultMessage: "2. Transfer categories to include"
};

var duplicateGridID = {
  id: "8b0fd1a8-aa1b-4eb6-9716-1f64d1c1cb82",
  defaultMessage: "Duplicate {gridID}"
};

export {
  dupicateModalTitle ,
  duplicateInto ,
  newGrid ,
  existingGrid ,
  duplicateSuccess ,
  duplicateFail ,
  duplicationDates ,
  periodSelection ,
  duplicateTransferHeader ,
  duplicateGridID ,
}
/* No side effect */
